export const VendaERPDefaultStatus = {
  Reprovadas: "65a6d999457d428464055968",
  AguardandoResposta: "65a6e12805018714654de441",
  Implementacoes: "65a6e14005018714654de442",
  Backlog: "65a6e15905018714654de443",
  ToDo: "65a6e16705018714654de444",
  Doing: "65a6e17c05018714654de445",
  ErrorFix: "65a6e18f05018714654de446",
  PrAguardando: "65a6e1a105018714654de447",
  PrAprovado: "65a6e1b505018714654de448",
  PublicadoEmHomologacao: "65a6e1ce05018714654de449",
  Testing: "65a6e1ee05018714654de44a",
  TestFinished: "65a6e20c05018714654de44b",
  Publicado: "65a6e22005018714654de44c",
  Triagem: "65b14608bc1197c6408ed376",
  FatorExterno: "65d4f184db686ea048638c18"
};
